// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"6711c574","832":"6711c574","981":"6e2e94b3"}[chunkId] + ".chunk.css";
};